// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Thymosin beta 4 09.17.26" (1d2f1089-9308-4c9b-bccb-dee69a0e8006). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiThymosinBeta4AnswerField } from './questions';

export const mdiThymosinBeta4: FormType<mdiThymosinBeta4AnswerField> = {
  name: 'Thymosin beta 4',
  validityLength: 25,
  questions: [
    {
      key: 'mdiThymosinBeta4_sex',
      next: {
        switch: [
          {
            condition: { 'mdiThymosinBeta4_sex.female': true },
            key: 'mdiThymosinBeta4_pregnancy'
          },
          {
            condition: { 'mdiThymosinBeta4_pregnancy.yes': true },
            key: 'mdiThymosinBeta4_wereSorryBasedPreviousAnswer'
          }
        ],
        els: 'mdiThymosinBeta4_importantClickAttachedLinkReview'
      }
    },
    {
      key: 'mdiThymosinBeta4_pregnancy',
      next: {
        condition: { 'mdiThymosinBeta4_pregnancy.yes': true },
        key: 'mdiThymosinBeta4_wereSorryBasedPreviousAnswer',
        els: 'mdiThymosinBeta4_importantClickAttachedLinkReview'
      }
    },
    'mdiThymosinBeta4_wereSorryBasedPreviousAnswer',
    'mdiThymosinBeta4_importantClickAttachedLinkReview',
    'mdiThymosinBeta4_reasonInterestedPeptide',
    {
      key: 'mdiThymosinBeta4_everUsedPeptideTherapiesPast',
      next: {
        condition: {
          'mdiThymosinBeta4_everUsedPeptideTherapiesPast.yes': true
        },
        key: 'mdiThymosinBeta4_peptidesUsedPreviously',
        els: 'mdiThymosinBeta4_everReactionSideEffectsPeptide'
      }
    },
    'mdiThymosinBeta4_peptidesUsedPreviously',
    {
      key: 'mdiThymosinBeta4_everReactionSideEffectsPeptide',
      next: {
        condition: {
          'mdiThymosinBeta4_everReactionSideEffectsPeptide.yes': true
        },
        key: 'mdiThymosinBeta4_reactionSideEffect',
        els: 'mdiThymosinBeta4_diagnosedRedFlagMedicalConditions'
      }
    },
    'mdiThymosinBeta4_reactionSideEffect',
    'mdiThymosinBeta4_diagnosedRedFlagMedicalConditions',
    'mdiThymosinBeta4_confirmNotHistoryCancerKidney',
    {
      key: 'mdiThymosinBeta4_takeRedFlagMedicationsSubstances',
      next: {
        condition: {
          'mdiThymosinBeta4_takeRedFlagMedicationsSubstances.alcohol_use': true
        },
        key: 'mdiThymosinBeta4_manyAlcoholicDrinksConsumePer',
        els: 'mdiThymosinBeta4_allergyBenzylPeroxide'
      }
    },
    'mdiThymosinBeta4_manyAlcoholicDrinksConsumePer',
    'mdiThymosinBeta4_allergyBenzylPeroxide',
    'mdiThymosinBeta4_lastTimePersonMedicalEvaluation',
    'mdiThymosinBeta4_confirmUnderstandContactDoctorQuestions',
    'mdiThymosinBeta4_firstMessageDoctor',
    'mdiThymosinBeta4_complete'
  ]
};
